export const collectionData = [
  {
    id: 'c1',
    title: 'Mascot for Divis Vanishers',
    src: '/images/collection/character-dv.jpg',
    category: 'collection',
    tags: ['logo'],
    social: 'https://www.behance.net/gallery/166747271/Divis-Vanishes-Mascot',
    createdDate: new Date('2022-03-25'),
    slug: '',
  },
  {
    id: 'c2',
    title: 'Logo for Divis Vanishers',
    src: '/images/collection/logo-dv.jpg',
    category: 'collection',
    tags: ['logo'],
    social: 'https://www.behance.net/gallery/166747159/Divis-Vanishers-Logo',
    createdDate: new Date('2022-04-25'),
    slug: '',
  },
  {
    id: 'c3',
    title: 'Cups pattern',
    src: '/images/collection/pattern-cups.jpg',
    category: 'collection',
    tags: ['pattern'],
    social: 'https://www.behance.net/gallery/166747699/Cup-Pattern',
    createdDate: new Date('2022-04-25'),
    slug: '',
  },
  {
    id: 'c4',
    title: 'Logo for Tralamo',
    src: '/images/collection/logo-tralamo.jpg',
    category: 'collection',
    tags: ['logo'],
    social: 'https://www.behance.net/gallery/166748135/Tralamo-Logo',
    createdDate: new Date('2022-04-25'),
    slug: '',
  },
  {
    id: 'c5',
    title: 'Logo for Sindhura Hospital',
    src: '/images/collection/logo-sh.jpeg',
    category: 'collection',
    tags: ['logo'],
    social: 'https://www.behance.net/gallery/166745759/Sindhura-Hospital-Logo',
    createdDate: new Date('2022-04-25'),
    slug: '',
  },
];
